import privateAxiosService from './privateAxiosService.ts';
import type { APITokenResponse } from './privateAxiosService.ts';

export type UserMeResponse = {
  id: number;
  playerid: string;
  testaccount: boolean;
  language: string;
};

export const getUserDemoToken = () =>
  privateAxiosService.post<APITokenResponse>('/auth/demo-token');

export const getUserTokenBySessionId = (sessionid: string, mode: string) =>
  privateAxiosService.post<APITokenResponse>('/auth/token', { sessionid, mode });

export const getUserMeAPI = () =>
  privateAxiosService.get<UserMeResponse>('/auth/me');
